module.exports = __webpack_public_path__ + "img/about-m-slide-8.54969867.jpg";